module.exports = __webpack_public_path__ + "fonts/164eb80f1b23f13fd588c464e69049d5.txt";